/* GiftInOne 2.14.17: click-based mobile layouts. Optional display geometry only. */
(function () {
  'use strict';
  if (window.GIOToolsDrawer) return;
  window.GIOToolsDrawer = {bind:function (options) {
    options=options||{};
    var main=options.main, pop=options.pop, side=options.side, handle=options.handle;
    var disposed=false, failed=false, listeners=[], observer=null, resizeFrame=0, sizeKey='';
    var empty={sync:function(){},destroy:function(){}};
    if(!main || !pop || !side || !handle)return empty;
    function on(el,type,fn,opts) {
      if(!el || !el.addEventListener)return;
      el.addEventListener(type,fn,opts);
      listeners.push(function(){el.removeEventListener(type,fn,opts);});
    }
    function mobile() { return window.matchMedia ? window.matchMedia('(max-width:760px)').matches : window.innerWidth<=760; }
    function inputMode() { return main.classList.contains('gio-mobile-input-active'); }
    function pixels(value) { var number=parseFloat(value);return Number.isFinite(number)?number:0; }
    function verticalBox(style) { return pixels(style.paddingTop)+pixels(style.paddingBottom)+pixels(style.borderTopWidth)+pixels(style.borderBottomWidth); }
    function visibleChild(el) { var css=getComputedStyle(el);return !el.hidden && css.display!=='none' && css.position!=='absolute' && css.position!=='fixed'; }
    function outerHeight(el) { var css=getComputedStyle(el);return el.getBoundingClientRect().height+pixels(css.marginTop)+pixels(css.marginBottom); }
    function clearGeometry() {
      // Sizing is enhancement-only: a failed measurement must leave the CSS
      // layouts usable and must never disable review, save, or add-to-cart.
      try { pop.style.removeProperty('--gio-drawer-height');pop.style.removeProperty('--gio-stage-min-height'); } catch(error) {}
      try { main.classList.remove('gio-tools-preview-hidden','gio-tools-resizing'); } catch(error) {}
    }
    function fallback() { failed=true;clearGeometry(); }
    // Measure surrounding controls, not the current canvas, so shrinking the
    // preview cannot feed its own result into the next layout calculation.
    function stageChrome() {
      var stage=pop.querySelector('.gio-editor-v2-stage');
      if(!stage)return 0;
      var child=stage.querySelector('.gio-design-canvas-wrap,.gio-template-canvas-wrap'), total=0;
      if(!child)return verticalBox(getComputedStyle(stage));
      total=verticalBox(getComputedStyle(child));
      while(child && child!==stage) {
        var parent=child.parentElement;if(!parent)break;
        var css=getComputedStyle(parent), count=0;
        total+=verticalBox(css)+pixels(getComputedStyle(child).marginTop)+pixels(getComputedStyle(child).marginBottom);
        Array.prototype.forEach.call(parent.children,function(sibling){
          if(!visibleChild(sibling))return;
          count++;if(sibling!==child)total+=outerHeight(sibling);
        });
        if(/^(flex|grid)$/.test(css.display))total+=Math.max(0,count-1)*pixels(css.rowGap);
        child=parent;
      }
      return total;
    }
    function bounds() {
      var css=getComputedStyle(pop), height=Math.max(0,pop.clientHeight-pixels(css.paddingTop)-pixels(css.paddingBottom)-pixels(css.rowGap));
      var bar=side.querySelector('.gio-editor-v2-drawer-bar'), tabs=side.querySelector('.gio-editor-v2-tabs');
      var low=Math.min(height,Math.ceil((bar&&visibleChild(bar)?outerHeight(bar):0)+(tabs&&visibleChild(tabs)?outerHeight(tabs):0)+verticalBox(getComputedStyle(side))));
      // The normal tools get usable control space first. On small screens the
      // target is flexible, never a hard minimum that pushes the footer away.
      var hidePreview=height<280;
      var thumbnail=hidePreview?0:Math.min(120,Math.max(80,height*.18));
      var preview=hidePreview?0:Math.min(Math.max(0,height-low-120),stageChrome()+thumbnail);
      var full=Math.max(low,height-preview);
      var desired=low+Math.min(240,Math.max(180,height*.36));
      var balanced=hidePreview?full:Math.max(low,Math.min(full,desired));
      return {height:height,collapsed:low,balanced:balanced,full:full,hidePreview:hidePreview};
    }
    function sync() {
      if(disposed)return;
      if(failed){clearGeometry();return;}
      try {
        var state=options.getState ? options.getState() : 'balanced';
        handle.setAttribute('aria-expanded',String(state!=='collapsed'));
        handle.setAttribute('aria-label',state==='full'?'Show a larger preview':'Show more tools');
        handle.setAttribute('title',state==='full'?'Show a larger preview':'Show more tools');
        // Text entry has a separate, keyboard-aware surface. It owns all room
        // while active; do not leave a stale normal-layout height on it.
        if(!mobile() || inputMode()){clearGeometry();return;}
        if(!pop.clientHeight)return;
        var b=bounds(), height=b[state];
        if(height===undefined)height=b.balanced;
        if(!Number.isFinite(height))throw new Error('Invalid tool layout');
        pop.style.setProperty('--gio-stage-min-height','0px');
        pop.style.setProperty('--gio-drawer-height',Math.max(0,Math.min(b.height,height)).toFixed(2)+'px');
        main.classList.toggle('gio-tools-preview-hidden',b.hidePreview&&state!=='collapsed');
      } catch(error) { fallback(); }
    }
    function change(state) {
      try {
        if(disposed || !mobile() || inputMode() || !main.classList.contains('tingle-modal--visible'))return;
        if(options.isBusy && options.isBusy())return;
        if(options.setState)options.setState(state,false);
      } catch(error) { fallback(); }
    }
    function resize() {
      if(disposed || resizeFrame)return;
      try {
        resizeFrame=requestAnimationFrame(function(){
          resizeFrame=0;
          try {
            var key=pop.clientWidth+':'+pop.clientHeight+':'+mobile()+':'+inputMode();
            if(key===sizeKey)return;sizeKey=key;sync();
          } catch(error) { fallback(); }
        });
      } catch(error) { sync(); }
    }
    // There are intentionally no pointer/touch drag handlers or capture here.
    // Host-app pull-down gestures cannot break the explicit layout buttons.
    try {
      on(handle,'click',function(e){
        e.preventDefault();
        try { change(options.getState()==='full'?'balanced':options.getState()==='collapsed'?'balanced':'full'); } catch(error) { fallback(); }
      });
      on(handle,'keydown',function(e){
        if(!/^(ArrowUp|ArrowDown|Home|End)$/.test(e.key))return;
        e.preventDefault();
        try {
          var state=options.getState();
          change(e.key==='Home'?'collapsed':e.key==='End'?'full':e.key==='ArrowUp'?(state==='collapsed'?'balanced':'full'):(state==='full'?'balanced':'collapsed'));
        } catch(error) { fallback(); }
      });
      if(window.ResizeObserver){observer=new ResizeObserver(resize);observer.observe(pop);}
      on(window,'resize',resize,{passive:true});
      sync();
    } catch(error) { fallback(); }
    return {sync:sync,destroy:function(){
      if(disposed)return;disposed=true;
      try { if(resizeFrame)cancelAnimationFrame(resizeFrame);if(observer)observer.disconnect(); } catch(error) {}
      resizeFrame=0;
      listeners.forEach(function(remove){try{remove();}catch(error){}});listeners=[];
      clearGeometry();
    }};
  }};
}());
